<div class="button-wrapper">
    <div class="last-group">
        <div class="last-group-permission-wrapper" *checkPermission="permissionEdit">
            <div ngbTooltip="{{'buttons.edit' | translate}}" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover" *ngIf="!edit">
                <button class="extra-button yellow" (click)="editForm($event)">
                    <img src="assets/ico/edit.svg" alt="edit" />
                </button>
            </div>
            <div ngbTooltip="{{'buttons.clone' | translate}}" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover" *ngIf="!edit && !hideClone">
                <button class="extra-button orange" (click)="cloneForm()">
                    <img src="assets/ico/copy-regular.svg" alt="clone" />
                </button>
            </div>
            <span ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover" *ngIf="!edit && subsection !== 'budget'">
                <app-modal-info title="Confirm action" [text]="deleteText" color="red" isQuestion="false"
                    iconSrc="assets/ico/trash-alt-regular.svg" (confirmEvent)="delete()">
                    <span action>
                        <button class="extra-button red" [class.disabled]="disableDelete">
                            <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
                        </button>
                    </span>
                </app-modal-info>
            </span>

            <div ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="!edit && subsection === 'budget'">
            <button class="extra-button red" [class.disabled]="disableDelete" (click)="budgetDeletion()">
                <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
            </button>
        </div>

            <span *ngIf="subsection == 'budget' && form.value.identifier && !edit"
            ngbTooltip="{{'buttons.fillBudget' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover">
            <button class="extra-button light-blue" (click)="budgetFill()">
                <img class="save" src="assets/ico/fill.svg" alt="projectManagement" />
            </button>
        </span>

        <div *ngIf="subsection == 'budget' && form.value.identifier && !edit"
            ngbTooltip="{{'buttons.projectManagement' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover">
            <button class="extra-button light-blue" (click)="newProject()">
                <img class="save" src="assets/ico/jira-brands.svg" alt="projectManagement" />
            </button>
        </div>
        </div>
        <div ngbTooltip="{{'buttons.save' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="edit">
            <button class="extra-button green" [disabled]="form.invalid"
                (click)="saveForm()">
                <img class="save" src="assets/ico/save.svg" alt="save" />
            </button>
        </div>
        <div ngbTooltip="{{'buttons.undo' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="edit">
            <button class="extra-button red" (click)="cancelForm()">
                <img class="undo" src="assets/ico/undo-24px.svg" alt="back" />
            </button>
        </div>
        <div *ngIf="edit && subsection == 'workinghours'">
            <button class="extra-button fulltime" (click)="fillFullTime()">
                <div class="button-icon icon fill-white" aria-label="clock" [inlineSVG]="'assets/ico/clock.svg'"></div>
                <div class="text">Full time</div>
            </button>
        </div>




    </div>
</div>